import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage, injectIntl} from 'react-intl';
import moment from 'moment';
import ExportForm from './ExportForm';
import {createExport, downloadExport, fetchExport} from '../../../actions/hdi/actionExport';
import Loader from '../../Loader';
import {
    HDI_EXPORT_FORM_FIELD_CHARSET,
    HDI_EXPORT_FORM_FIELD_TYPE,
    XLS
} from '../../../constants/exportConstants';
import PageHeader from '../../common/PageHeader';
import checkRoles from '../../common/roleChecker/RoleChecker';
import {getEditorSolutionGroups} from '../../../actions/admin/actionAdminEditor';
import {moduleRoles} from '../../../utils/roles';

class ExportPage extends Component {
    componentDidMount() {
        this.props.fetchExport();
        this.props.getEditorSolutionGroups();
    }

    handleSubmit = (values) => {
        const temp = JSON.parse(JSON.stringify((({solutionGroup}) => {
            return ({
                solutionGroup: solutionGroup ? solutionGroup.trim() : undefined
            });
        })(values)));

        const exportFilter = {};
        exportFilter.filter = [];
        for (let key in temp) {
            if (temp.hasOwnProperty(key)) {
                exportFilter.filter.push({id: key, value: temp[key]})
            }
        }

        if (values.group) {
            exportFilter.group = values.group;
        }
        if (values.from) {
            exportFilter.from = moment(values.from).add(12, 'hours').toISOString().substr(0, 10);
        }
        if (values.to) {
            exportFilter.to = moment(values.to).add(12, 'hours').toISOString().substr(0, 10);
        }
        exportFilter.type = values.type;
        if (!exportFilter.type) {
            exportFilter.type = XLS;
        }
        exportFilter.charset = values.charset;
        this.props.createExport(exportFilter);
    };

    downloadExport = () => {
        this.props.downloadExport(this.props.exportRecord);
    };

    render() {
        const {isLoadingExport, charSets, isSolutionGroupListLoading} = this.props;

        if (isLoadingExport || isSolutionGroupListLoading) {
            return <Loader/>;
        }

        return (
            <div className="container-fluid">
                <PageHeader title={<FormattedMessage id="hdi.export.header" defaultMessage="Export"/>}/>
                <ExportForm onSubmit={this.handleSubmit}
                                 downloadExport={this.downloadExport}
                                 form={'hdiExportForm'}
                                 initialValues={{
                                     [HDI_EXPORT_FORM_FIELD_TYPE]: XLS,
                                     [HDI_EXPORT_FORM_FIELD_CHARSET]: charSets[0]
                                 }}
                />
            </div>
        );
    }
}

ExportPage.propTypes = {
    isLoadingExport: PropTypes.bool.isRequired,
    exportRecord: PropTypes.object.isRequired,
    fetchExport: PropTypes.func.isRequired,
    createExport: PropTypes.func.isRequired,
    downloadExport: PropTypes.func.isRequired,
    charSets: PropTypes.array.isRequired,
    getEditorSolutionGroups: PropTypes.func.isRequired,
    isSolutionGroupListLoading: PropTypes.any,
};

const mapStateToProps = state => ({
    isLoadingExport: state.exportTickets.isLoadingExport,
    exportRecord: state.exportTickets.exportRecord,
    charSets: state.profile.userDetail.charSets,
    isSolutionGroupListLoading: state.adminSolutionGroupList.isSolutionGroupListLoading,
});

export default checkRoles(connect(mapStateToProps, {
    fetchExport,
    createExport,
    downloadExport,
    getEditorSolutionGroups
})(injectIntl(ExportPage)), ['HDI_ADMIN']);
